// Setup Advisor entry points (the home picker, the collection chips and the "Free Setup Advisor" button) render with
// data-ns-advisor-gate and hidden; they show only once the Worker says the Advisor answers, so a store without its
// Anthropic key never shows a dead block. The answer is kept in the tab for ten minutes, so browsing asks the Worker once.
export const STATUS_URL = '/apps/9space/advisor/status';
export const READY_KEY = 'ns-advisor-ready';
const FRESH_MS = 10 * 60 * 1000;

export function readyFrom(storage, now) {
  try {
    const note = JSON.parse(storage?.getItem(READY_KEY) ?? 'null');
    return note && typeof note.ready === 'boolean' && now - note.at >= 0 && now - note.at < FRESH_MS ? note.ready : null;
  } catch {
    return null;
  }
}

export function saveReady(storage, ready, now) {
  try { storage?.setItem(READY_KEY, JSON.stringify({ ready, at: now })); } catch { /* private mode: ask again next page */ }
}

// null when the Worker could not be asked (offline, a 5xx): the block stays hidden on this page, and the next page asks again.
export async function ask(fetcher = fetch) {
  try {
    const response = await fetcher(STATUS_URL, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return (await response.json())?.ready === true;
  } catch {
    return null;
  }
}

if (typeof document !== 'undefined') {
  const nodes = document.querySelectorAll('[data-ns-advisor-gate]');
  if (nodes.length) {
    const storage = (() => { try { return window.sessionStorage; } catch { return null; } })();
    const known = readyFrom(storage, Date.now());
    const ready = known ?? await ask();
    if (known === null && ready !== null) saveReady(storage, ready, Date.now());
    for (const node of document.querySelectorAll('[data-ns-advisor-gate]')) node.hidden = ready !== true;
  }
}
